import type { Spacings } from '@rulebooks/evidend-titan';
import { Block, Card } from '@rulebooks/evidend-titan';
import type { Party } from 'generated/gql';
import { getPartyName } from 'helpers/getFromParty';
import React from 'react';

interface PartyCardProps {
  party: Party;
  spaceAfter?: Spacings;
  backgroundVariant: 'white' | 'grey';
  compareDeceaseDate?: Date;
}
const PartyCard = ({
  party,
  spaceAfter = 6,
  backgroundVariant = 'white',
  compareDeceaseDate,
}: PartyCardProps) => {
  return (
    <Card backgroundVariant={backgroundVariant} spaceAfter={spaceAfter}>
      <Block>{getPartyName(party, compareDeceaseDate)}</Block>
    </Card>
  );
};

export default PartyCard;
